import { Component, OnInit, ViewChild } from '@angular/core';
import { RequestService } from '../../../../services/request.service';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router, ActivatedRoute } from "@angular/router";
import { DataTableDirective} from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';

declare const $: any;

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.scss']
})
export class DevicesComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
	dtElement: DataTableDirective;
	dtOptions: any = {};
	// dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  isEditMode: boolean = false;
  deviceForm: any = {}
 

  constructor(
    private request: RequestService,
    private http: HttpClient,
    private router: Router,
    private datePipe : DatePipe
  ) { }


  isLoading=false;
  ngOnInit() {
    this.ViewDevices();

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
        buttons: [
        {
          extend: 'csv',
          text:      '<i class="fa fa-file-text-o"></i>',
          titleAttr: 'Download as CSV',
          title: 'Device Master' 
        },
        {
          extend: 'excel',
          text:      '<i class="fa fa-file-excel-o"></i>',
          titleAttr: 'Download as Excel',
          title: 'Device Master' 
        },
        {
          extend: 'pdf',
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: 'Download as Pdf',
          title: 'Device Master' 
        }
      ]
    };
   
  }

  ClearForm(){
    this.isEditMode=false;
    this.deviceForm={};
  }

  deviceViewDetails;
  async EditDevice(device_id){
    try {
      this.isEditMode=true;
      const device = {
        'device_id': device_id,
      };
      const data: any = await this.request.post('/master/view_device',device);
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            dataObj[objKey1].manufacturing_date = this.normalizeTimestamp(Number(dataObj[objKey1].manufacturing_date));
            dataObj[objKey1].date_time = this.normalizeTimestamp(Number(dataObj[objKey1].date_time));
            this.deviceViewDetails = dataObj[objKey1];
          } 
        }				
      }
      this.deviceForm = this.deviceViewDetails;
      this.deviceForm.manufacturing_date = this.datePipe.transform(new Date(this.deviceForm.manufacturing_date), 'yyyy-MM-dd');
      // alert(">> "+this.deviceViewDetails);
    } catch (error) {}
  }

  normalizeTimestamp(timestamp: number): number {
    const length = timestamp.toString().length;

    if (length === 10) {
      // Convert seconds → milliseconds
      return timestamp * 1000;
    } else if (length === 13) {
      // Already in milliseconds
      return timestamp;
    } else {
      throw new Error("Invalid timestamp format");
    }
  }
 
  //Delete Devices
  async DeleteDevice(device_id) {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
      });
      if (confirm.value) {
      const device = {
        'device_id': device_id
      };
      const allow: any = await this.request.post('/master/delete_device/',device);
      if (allow) {
      // Successfully Deleted
      Swal.fire(
      'Deleted!',
      'Device Information has been deleted.',
      'success'
      );
      // Reload DataTable
      // this.ViewDrivers();
      window.location.reload();
      // this.ngOnInit();
      } else {
      Swal.fire(
        'Error!'
      );
      }
    }
  }

  //View Devices
  deviceRowdata:any;
  deviceDetails=[];
  async ViewDevices(){
    try {
      this.isLoading=true;
      // alert("here");
      const device = {
        'device_id': "",
      };
      this.dtTrigger=new Subject<any>();
      const data: any = await this.request.post('/master/view_device',device);
      this.deviceDetails=[];
      //alert(data);
      this.dtTrigger.next();
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            if(dataObj[objKey1].manufacturing_date==0){
              dataObj[objKey1].manufacturing_date = dataObj[objKey1].date_time;
            }
            dataObj[objKey1].manufacturing_date = this.normalizeTimestamp(Number(dataObj[objKey1].manufacturing_date));
            dataObj[objKey1].date_time = this.normalizeTimestamp(Number(dataObj[objKey1].date_time));
            this.deviceDetails.push(dataObj[objKey1]);
          } 
        }				
      }
      this.deviceRowdata = this.deviceDetails;
      // console.log(this.deviceRowdata);
      this.isLoading=false;
    } catch (error) {}
  }

  onSubmit(): void {
  if (this.isEditMode) {
    this.UpdateDevices();
  } else {
    this.SaveDevices();
  }
}

  isViewMode = false;
  isUpdatedRecord;
  message;
  async SaveDevices() {
    try {
      const deviceData = {
        'device_id':this.deviceForm.device_id,
        'description': this.deviceForm.description,
        'model_no': this.deviceForm.model_no,
        'manufacturing_date': new Date(this.deviceForm.manufacturing_date).getTime(),
        'version': this.deviceForm.version,
        'assigned_status':1
      };
      console.log(deviceData);
      const save: any = await this.request.post('/master/add_device',deviceData);
      for (let objKey of Object.keys(save)) {
        let dataObj = save[objKey];
        if(objKey=="status"){
        this.isUpdatedRecord = save[objKey];
        }
        if(objKey=="message"){
        this.message = save[objKey];
        }
      }
      if (this.isUpdatedRecord=="SUCCESS") {
        // alert("Save Successfully");
        const result = await Swal.fire({
        title: 'Successfully Save',
        text: 'Saved Changes.',
        type: 'success',
        showConfirmButton: false,  
        timer: 1500
        // confirmButtonText: 'Ok'
        });
        if (result.value) {
        // Form Reset
        window.location.reload();
        }
        window.location.reload();
      } else{
        const result = await Swal.fire({
          title: "Oops ?",
          text: this.message,   
          type: "warning",   
          showCancelButton: false,      
          confirmButtonColor: "#FF0000",   
          confirmButtonText: "Close",   
          closeOnConfirm: false,   
          closeOnCancel: false,
          customClass: "Custom_Cancel"
        });
      }
      this.isEditMode=false;
      this.isViewMode=false;
    } catch (error) { }

  }

  async UpdateDevices() {
    try {
      const deviceData = {
        'devId':this.deviceForm.devId,
        'device_id':this.deviceForm.device_id,
        'description': this.deviceForm.description,
        'model_no': this.deviceForm.model_no,
        'manufacturing_date': new Date(this.deviceForm.manufacturing_date).getTime(),
        'version': this.deviceForm.version,
        'assigned_status':1
      };
      console.log(deviceData);
      const save: any = await this.request.post('/master/update_device',deviceData);
      for (let objKey of Object.keys(save)) {
        let dataObj = save[objKey];
        if(objKey=="status"){
        this.isUpdatedRecord = save[objKey];
        }
        if(objKey=="message"){
        this.message = save[objKey];
        }
      }
      if (this.isUpdatedRecord=="SUCCESS") {
        // alert("Save Successfully");
        const result = await Swal.fire({
        title: 'Successfully Save',
        text: 'Saved Changes.',
        type: 'success',
        showConfirmButton: false,  
        timer: 1500
        // confirmButtonText: 'Ok'
        });
        if (result.value) {
        // Form Reset
        window.location.reload();
        }
        window.location.reload();
      } else{
        const result = await Swal.fire({
          title: "Oops ?",
          text: this.message,   
          type: "warning",   
          showCancelButton: false,      
          confirmButtonColor: "#FF0000",   
          confirmButtonText: "Close",   
          closeOnConfirm: false,   
          closeOnCancel: false,
          customClass: "Custom_Cancel"
        });
      }
      this.isEditMode=false;
      this.isViewMode=false;
    } catch (error) { }

  }

  
}













